const getTimeZoneOptions = () => {
  const popularTimeZones = ['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'Europe/London', 'Europe/Berlin', 'Asia/Tokyo', 'Asia/Shanghai', 'Asia/Kolkata', 'Australia/Sydney'];
  const allTimeZones = typeof Intl?.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];
  const otherTimeZones = allTimeZones.filter((tz) => !popularTimeZones.includes(tz));
  return [...popularTimeZones, ...otherTimeZones];
};

export default getTimeZoneOptions;
